import { ChangeDetectionStrategy, Component } from '@angular/core';

import { SubscriptionPlan } from '@vi-iot/client';
import { FlatBookingPlansSpecification } from './flat-booking-plans-specification';

@Component({
  selector: 'app-flat-booking-plans-spec',
  templateUrl: './flat-booking-plans-spec.component.html',
  styleUrls: ['./flat-booking-plans-spec.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlatBookingPlansSpecComponent {
  readonly subscriptionsPlanType = SubscriptionPlan;
  readonly flatBookingPlansSpecification = FlatBookingPlansSpecification;
}
